module.exports = __webpack_public_path__ + "img/image_indisponivel.0963e43b.gif";